module.exports = __webpack_public_path__ + "2d3cef91fbb6377e40398891b90d29bf.ttf";